import getGqlQuery from 'common/helpers/getters/getGqlQuery'
import { formatPrice } from 'common/helpers'
import { reducers } from 'redux/core'
import request from 'sb-request'


const fetch = () => {
  reducers.view.caseMonthlyDesignPage.setFetching(true)

  request.post('graphql?name=perfumeCaseOfMonth', {
    body: {
      query: `{
        perfumeCaseOfMonth {
          price
          enabled
          selected
          selectionLocked
          currentMonth {
            monthName
            product {
              url
              img
              name
            }
          }
        }
      }`,
    },
    modifyResult: ({ perfumeCaseOfMonth: { currentMonth, price, ...rest } = {} }) => ({
      ...rest,
      ...(currentMonth || {}),
      price: formatPrice(price, true, true, 2),
    }),
  })
    .then(
      (response) => reducers.view.caseMonthlyDesignPage.setData(response),
      () => reducers.view.caseMonthlyDesignPage.setFetching(false)
    )
}

const setSelectedStatus = ({ enabled, page }) => (
  request.post('graphql?name=setUpchargeForPerfumeCase', {
    body: {
      query: `
        mutation {
          ${getGqlQuery('setUpchargeForPerfumeCase', { enabled, page })} {
            selected
          }
        }
      `,
    },
  }).then(() => reducers.view.caseMonthlyDesignPage.setSelected(enabled))
)

// eslint-disable-next-line prefer-destructuring
const reset = reducers.view.caseMonthlyDesignPage.reset

export default {
  fetch,
  reset,
  setSelectedStatus,
}
